

import React, { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import { firebaseConfig } from './firebase'

import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
// import { GoogleMap, Marker, InfoWindow, useLoadScript } from "@react-google-maps/api";
import { CalendarMonth, ComputerSharp } from '@mui/icons-material';
import { FaWrench } from 'react-icons/fa';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import './Offers.scss'
import { toast } from "react-toastify";
import { db } from "../firebase.js";
import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import GrassIcon from '@mui/icons-material/Grass';
import ConstructionIcon from '@mui/icons-material/Construction';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import VillaIcon from '@mui/icons-material/Villa';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import FoundationIcon from '@mui/icons-material/Foundation';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import HouseSidingIcon from '@mui/icons-material/HouseSiding';
import FenceIcon from '@mui/icons-material/Fence';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddIcon from '@mui/icons-material/Add';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import GavelIcon from '@mui/icons-material/Gavel';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CottageIcon from '@mui/icons-material/Cottage';
import PaidIcon from '@mui/icons-material/Paid';
import ListingItem from "../components/ListingItem.jsx";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NewPatientModal from './NewPatientModal.jsx.jsx'
import { Button } from 'react-bootstrap';
import LockIcon from '@mui/icons-material/Lock';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportIcon from '@mui/icons-material/Support';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import HouseIcon from '@mui/icons-material/House';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PieChartIcon from '@mui/icons-material/PieChart';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddHomeIcon from '@mui/icons-material/AddHome';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import { getAuth } from "firebase/auth";
import Contact from "../components/Contact";
import { doSignOut } from "./auth.js";
import { useAuth } from "./authContext";
import VisibilityIcon from '@mui/icons-material/Visibility';
import GaugeComponent from 'react-gauge-component';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {
  FaBath,
  FaBed,
  FaChair,
  FaMapMarkerAlt,
  FaParking,
  FaShare,
} from "react-icons/fa";
import { CardMedia } from "@mui/material";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import PeopleIcon from '@mui/icons-material/People';
import { Chip } from "@mui/material";
import StateModal from "./StateModal.jsx";
import TenantModal from "./TenantModal.jsx";
import ProfileComponent from "./ProfileComponent.jsx";
import UpsellModal from "./UpsellModal.jsx";
import { CreditCard } from "@mui/icons-material";

firebase.initializeApp(firebaseConfig);

const RentCast = () => {
  const auth = getAuth();
  const { currentUser } = useAuth()

  let propertyInfoState = {"status":{"version":"1.0.0","code":0,"msg":"SuccessWithResult","total":1,"page":1,"pagesize":10,"responseDateTime":"2025-01-11T00:02:35.517Z","transactionID":"8ad1bde58d6a9392faea9f45c84a18e4","attomId":20871108},"echoed_fields":{"jobID":"","loanNumber":"","preparedBy":"","resellerID":"","preparedFor":""},"property":[{"identifier":{"Id":20871108,"fips":"12101","apn":"33-26-16-0010-00000-0130","attomId":20871108},"lot":{"lotNum":"13","lotSize1":1.143,"lotSize2":"","zoningType":"Residential"},"area":{"countrySecSubd":"","subdName":"","subdTractNum":"10","censusTractIdent":"31504","censusBlockGroup":"1"},"address":{"country":"US","countrySubd":"FL","line1":"1045 POMME DE PIN LN","line2":"NEW PORT RICHEY, FL 34655","locality":"NEW PORT RICHEY","matchCode":"ExaStr","oneLine":"1045 POMME DE PIN LN, NEW PORT RICHEY, FL 34655","postal1":"34655","postal2":"5627","postal3":"R042"},"location":{"accuracy":"Rooftop","latitude":null,"longitude":null,"distance":0.0,"geoid":"CO12101, CS1292327, DB1201530, RS0005106652, SB0000079295, SB0000079307, SB0000079315, SB0000143836, SB0000147384, SB0000147385, SB0000147386, ZI34655","geoIdV4":{"CO":"43d38fa8a37eafe030e10c5b53c5bd73","CS":"fab542d89815cdf2e38ff937d038481e","DB":"f2a126c8f18b9f90bbbdbcf86f2fac1f","SB":"418b019a9fcac39ea7560567915609df, 69b89e32d70180e64fbfac8848d7b44d, 602ed0400ff61d9ae5b9b17c72a2c224, bb0dda43a6d5cbd57abb3625023c6d21, e88ef385d3ec54d59e06ec0038b4a241, 342727f89bb7ab95dfe5cb60601603c4, 666dc7112ef3083a84d29a2e6f48050c","ZI":"2170e60087a29ac75e0cc1ad7a38d1e4"}},"summary":{"absenteeInd":"OWNER OCCUPIED","propClass":"Single Family Residence / Townhouse","propSubType":"Residential","propType":"SFR","propertyType":"","yearBuilt":"","propLandUse":"SFR","propIndicator":10,"legal1":"RIVIERA PB 28 PGS 23-27 LOT 13 OR 3548 PG 1028"},"utilities":{"coolingType":"","heatingFuel":"ELECTRIC","heatingType":"","wallType":""},"sale":{"saleAmountData":{"saleDisclosureType":0}},"building":{"size":{"bldgSize":"","grossSize":3870.0,"grossSizeAdjusted":2869.0,"groundFloorSize":1630.0,"livingSize":"","sizeInd":"LIVING SQFT","universalSize":""},"rooms":{"bathsFull":"","bathsTotal":""},"interior":{"floors":"","fplcCount":1,"fplcInd":"Y","fplcType":"YES"},"construction":{"condition":"EXCELLENT"},"parking":{"prkgSize":644.0},"summary":{"levels":2,"view":"VIEW - NONE","viewCode":"000"}},"assessment":{"appraised":{},"assessed":{"assdImprValue":"","assdLandValue":"","assdTtlValue":""},"market":{"mktImprValue":511723.0,"mktLandValue":"","mktTtlValue":""},"tax":{"taxAmt":"","taxPerSizeUnit":1.41,"taxYear":"","exemption":{},"exemptiontype":{"Additional":"Y"}},"improvementPercent":61,"owner":{"corporateIndicator":"N","owner1":{"fullName":"","lastName":"T ","firstNameAndMi":"ROSSI ROBERT"},"owner2":{"fullName":"PATRICIA BARNES","lastName":"BARNES ","firstNameAndMi":"PATRICIA "},"owner3":{},"owner4":{},"absenteeOwnerStatus":"O","mailingAddressOneLine":"1045 POMME DE PIN LN, NEW PORT RICHEY, FL 34655-5627"},"mortgage":{"FirstConcurrent":{},"SecondConcurrent":{}}},"vintage":{"lastModified":"2024-11-22","pubDate":"2024-11-22"}}]}
  let crimeDataState = {"status":{"version":"4","code":0,"msg":"SuccessWithResult","total":0,"page":0,"pageSize":0,"transactionID":"0f79b97e68cf1b532bb573c915e1e87e"},"community":{"geography":{"geoIdV4":"43d38fa8a37eafe030e10c5b53c5bd73","geographyName":"Pasco County, FL","geographyTypeName":"County","area_Square_Mile":1072.21,"longitude":0,"latitude":0},"demographics":{"population_2000":344768,"population_2010":464764,"population_2020":561891,"population":0,"population_5_Yr_Projection":0,"population_Density_Sq_Mi":827.8,"population_3P":600164,"population_5P":588538,"population_Male_15P":250989,"population_Female_15P":265889,"population_16P":508717,"population_18P":493682,"population_Employed_16P":258887,"population_25P":447284,"population_Civilian_16P":259165,"population_Civilian_White_Collar_Or_Blue_Collar_16P":215131,"population_Daytime":533199,"population_Chg_Pct_2000":79.27,"population_Chg_Pct_2010":32.99,"population_Chg_Pct_2020":10.00,"population_Chg_Pct_5_Yr_Projection":7.25,"households_2000":147566,"households_2010":189636,"households_2020":225214,"households":257226,"households_5_Yr_Projection":281155,"household_Chg_Pct_2000":74.31,"household_Chg_Pct_2010":35.64,"household_Chg_Pct_2020":14.21,"household_Chg_Pct_5_Yr_Projection":9.30,"household_Size_Avg":2.37,"population_Family_Pct":82.67,"population_Non_Family_Pct":17.33,"households_Family":170473,"households_Non_Family":86753,"households_Family_Pct":66.27,"households_Non_Family_Pct":33.73,"households_Family_Married_Pct":50.87,"households_Family_Other_Pct":15.40,"hh_Fam_Other_Male_Householder_No_Wife_Present_Pct":4.32,"hh_Fam_Other_Female_Householder_No_Husband_Present_Pct":11.09,"hh_Fam_Married_W_Children_L18_Pct":19.54,"hh_Fam_Married_Wo_Children_L18_Pct":31.33,"hh_Fam_Other_Male_Hh_No_Wife_Present_W_Children_L18_Pct":2.62,"hh_Fam_Other_Male_Hh_No_Wife_Present_Wo_Children_L18_Pct":1.69,"hh_Fam_Other_Female_Hh_No_Husband_Pres_W_Children_L18_Pct":6.36,"hh_Fam_Other_Female_Hh_No_Husband_Pres_Wo_Children_L18_Pct":4.72,"hh_Non_Family_Male_Householder_Pct":15.98,"hh_Non_Family_Male_Hh_W_Children_L18_Pct":0.17,"hh_Non_Family_Male_Hh_Wo_Children_L18_Pct":15.81,"hh_Non_Family_Female_Householder_Pct":17.75,"hh_Non_Family_Female_Hh_W_Children_L18_Pct":0.10,"hh_Non_Family_Female_Hh_Wo_Children_L18_Pct":17.65,"households_Family_W_Children_Pct":28.53,"households_Family_Wo_Children_Pct":37.75,"households_Non_Family_W_Children_Pct":0.27,"households_Non_Family_Wo_Children_Pct":33.5,"population_Urban_Pct":88.45,"population_Rural_Pct":11.55,"population_Male_Pct":48.71,"population_Female_Pct":51.29,"population_White_Pct":72.29,"population_Black_Pct":6.37,"population_Asian_Pct":3.31,"population_American_Indian_Or_Alaskan_Native_Pct":0.40,"population_Multiracial_Pct":12.57,"population_Other_Race_Pct":5.07,"population_White_Hispanic_Pct":5.34,"population_White_Non_Hispanic_Pct":66.95,"population_Non_White_Hispanic_Pct":11.71,"population_Non_White_Non_Hispanic_Pct":16.00,"population_Hispanic_Pct":17.05,"population_Non_Hispanic_Pct":82.95,"households_White_Pct":79.72,"households_Black_Pct":5.59,"households_Asian_Pct":2.61,"households_American_Indian_Or_Alaskan_Native_Pct":0.45,"households_Multiracial_Pct":3.82,"households_Other_Race_Pct":7.79,"households_White_Hispanic_Pct":6.53,"households_White_Non_Hispanic_Pct":73.19,"households_Non_White_Hispanic_Pct":7.25,"households_Non_White_Non_Hispanic_Pct":13.02,"households_Hispanic_Pct":13.78,"households_Non_Hispanic_Pct":86.22,"median_Age":44.4,"population_Aged_0_5_Pct":5.96,"population_Aged_6_11_Pct":6.83,"population_Aged_12_17_Pct":7.34,"population_Aged_18_24_Pct":7.51,"population_Aged_25_34_Pct":10.84,"population_Aged_35_44_Pct":12.29,"population_Aged_45_54_Pct":12.64,"population_Aged_55_64_Pct":13.22,"population_Aged_65_74_Pct":12.72,"population_Aged_75_84_Pct":7.60,"population_Aged_85P_Pct":3.05,"white_Median_Age":48.2,"black_Median_Age":38.1,"asian_Median_Age":41.8,"american_Indian_Or_Alaskan_Native_Median_Age":36.4,"multiracial_Median_Age":30.7,"other_Race_Median_Age":37.1,"hispanic_Median_Age":34.8,"white_Non_Hispanic_Median_Age":49.6,"male_Median_Age":43.6,"female_Median_Age":45.2,"population_Male_Aged_0_5_Pct":5.75,"population_Male_Aged_6_11_Pct":7.05,"population_Male_Aged_12_17_Pct":7.62,"population_Male_Aged_18_24_Pct":7.88,"population_Male_Aged_25_34_Pct":10.87,"population_Male_Aged_35_44_Pct":12.64,"population_Male_Aged_45_54_Pct":12.90,"population_Male_Aged_55_64_Pct":13.13,"population_Male_Aged_65_74_Pct":12.15,"population_Male_Aged_75_84_Pct":7.29,"population_Male_Aged_85P_Pct":2.73,"population_Female_Aged_0_5_Pct":6.15,"population_Female_Aged_6_11_Pct":6.62,"population_Female_Aged_12_17_Pct":7.07,"population_Female_Aged_18_24_Pct":7.15,"population_Female_Aged_25_34_Pct":10.82,"population_Female_Aged_35_44_Pct":11.96,"population_Female_Aged_45_54_Pct":12.40,"population_Female_Aged_55_64_Pct":13.31,"population_Female_Aged_65_74_Pct":13.26,"population_Female_Aged_75_84_Pct":7.90,"population_Female_Aged_85P_Pct":3.35,"population_Males_Never_Married_Pct":29.60,"population_Males_Widowed_Pct":4.42,"population_Males_Divorced_Pct":10.71,"population_Males_Married_Pct":55.27,"population_Males_Married_And_Together_Pct":51.95,"population_Males_Married_And_Separated_Pct":1.44,"population_Males_Married_And_Absent_Pct":1.89,"population_Females_Never_Married_Pct":23.74,"population_Females_Widowed_Pct":11.06,"population_Females_Divorced_Pct":14.91,"population_Females_Married_Pct":50.29,"population_Females_Married_And_Together_Pct":46.93,"population_Females_Married_And_Separated_Pct":1.43,"population_Females_Married_And_Absent_Pct":1.93,"population_Primary_Language_English_Pct":83.37,"population_Primary_Language_Spanish_Pct":10.37,"population_Primary_Language_Other_Indo_European_Pct":3.55,"population_Primary_Language_Asian_Or_Other_Pacific_Island_Pct":1.80,"population_Primary_Language_Other_Pct":0.90,"population_Citizen_Native_Pct":89.24,"population_Citizen_Naturalized_Pct":6.79,"population_Non_Citizen_Pct":3.98,"population_Group_Quarters_Pct":1.37,"population_Institutional_Group_Quarters_Pct":0.95,"population_Non_Institutional_Group_Quarters_Pct":0.42,"population_In_Poverty_Pct":11.40,"population_Veterans_Pct":9.74,"family_Median_Size":3.20,"families_1_Person_Pct":0.00,"families_2_Persons_Pct":46.44,"families_3_Persons_Pct":22.55,"families_4_Persons_Pct":17.68,"families_5_Persons_Pct":8.90,"families_6_Persons_Pct":2.77,"families_7_Or_More_Persons_Pct":1.66,"non_Family_Median_Size":1.60,"non_Families_1_Person_Pct":82.93,"non_Families_2_Persons_Pct":14.78,"non_Families_3_Persons_Pct":1.52,"non_Families_4_Persons_Pct":0.46,"non_Families_5_Persons_Pct":0.20,"non_Families_6_Persons_Pct":0.10,"non_Families_7_Or_More_Persons_Pct":0.01,"median_Travel_Time_To_Work_Mi":29,"travel_Time_To_Work_0_14_Mi_Pct":19.94,"travel_Time_To_Work_15_29_Mi_Pct":29.37,"travel_Time_To_Work_30_59_Mi_Pct":36.91,"travel_Time_To_Work_60_89_Mi_Pct":10.47,"travel_Time_To_Work_90_Or_More_Mi_Pct":3.31,"transportation_Public_Pct":0.51,"transportation_Car_Pct":82.57,"transportation_Motorcycle_Pct":0.24,"transportation_Bicycle_Pct":0.22,"transportation_Walk_Pct":0.88,"transportation_Other_Pct":1.46,"transportation_Work_From_Home_Pct":14.13,"transportation_Public_Bus_Pct":0.51,"transportation_Public_Trolley_Pct":0.00,"transportation_Public_Light_Rail_Pct":0.00,"transportation_Public_Railroad_Pct":0.00,"transportation_Public_Ferry_Pct":0.00,"transportation_Public_Taxi_Pct":0.11,"transportation_Car_Alone_Pct":74.22,"transportation_Car_Carpool_Pct":8.35,"householder_Median_Age":56.8,"householder_Age_0_24_Pct":1.84,"householder_Age_25_34_Pct":10.63,"householder_Age_35_44_Pct":15.83,"householder_Age_45_54_Pct":18.08,"householder_Age_55_64_Pct":20.34,"householder_Age_65_74_Pct":18.50,"householder_Age_75_84_Pct":10.77,"householder_Age_85_And_Over_Pct":4.01,"median_Household_Size":2.60,"households_1_Person_Pct":27.97,"households_2_Persons_Pct":35.76,"households_3_Persons_Pct":15.45,"households_4_Persons_Pct":11.87,"households_5_Persons_Pct":5.97,"households_6_Persons_Pct":1.87,"households_7_Or_More_Persons_Pct":1.10,"housing_Units":287429,"housing_Units_Occupied":257226,"housing_Units_Vacant":30203,"housing_Units_Occupied_Pct":89.49,"housing_Units_Vacant_Pct":10.51,"housing_Units_Vacant_For_Rent_Pct":9.72,"housing_Units_Vacant_Rented_Not_Occupied_Pct":1.49,"housing_Units_Vacant_For_Sale_Pct":9.23,"housing_Units_Vacant_Sold_Not_Occupied_Pct":4.32,"housing_Units_Vacant_Seasonal_Pct":54.94,"housing_Units_Vacant_For_Migrant_Workers_Pct":0.61,"housing_Units_Vacant_Other_Pct":19.68,"housing_Units_Owner_Occupied":192499,"housing_Units_Renter_Occupied":64727,"housing_Units_Owner_Occupied_Pct":74.84,"housing_Units_Renter_Occupied_Pct":25.16,"housing_Occupied_Structure_1_Unit_Detached_Pct":65.48,"housing_Occupied_Structure_1_Unit_Attached_Pct":6.00,"housing_Occupied_Structure_2_Units_Pct":0.94,"housing_Occupied_Structure_3_4_Units_Pct":2.15,"housing_Occupied_Structure_5_9_Units_Pct":2.64,"housing_Occupied_Structure_10_19_Units_Pct":2.15,"housing_Occupied_Structure_20_49_Units_Pct":1.49,"housing_Occupied_Structure_50_Or_More_Units_Pct":2.41,"housing_Occupied_Structure_Trailer_Pct":16.53,"housing_Occupied_Structure_Other_Pct":0.21,"housing_Median_Rent":959,"housing_Rent_Less_Than_250_Pct":2.12,"housing_Rent_250_499_Pct":4.92,"housing_Rent_500_749_Pct":16.52,"housing_Rent_750_999_Pct":28.63,"housing_Rent_1000_1249_Pct":17.21,"housing_Rent_1250_1499_Pct":9.86,"housing_Rent_1500_1999_Pct":12.14,"housing_Rent_2000_Or_More_Pct":3.63,"housing_Rent_No_Cash_Pct":4.96,"housing_Owner_Households_With_Mortgage_Pct":55.78,"housing_Owner_Households_Without_Mortgage_Pct":44.22,"housing_Owner_Households_Median_Value":198089,"housing_Owner_Households_Valued_Less_Than_10000_Pct":1.45,"housing_Owner_Households_Valued_10000_14999_Pct":1.17,"housing_Owner_Households_Valued_15000_19999_Pct":1.37,"housing_Owner_Households_Valued_20000_24999_Pct":1.30,"housing_Owner_Households_Valued_25000_29999_Pct":1.19,"housing_Owner_Households_Valued_30000_34999_Pct":0.90,"housing_Owner_Households_Valued_35000_39999_Pct":0.84,"housing_Owner_Households_Valued_40000_49999_Pct":2.00,"housing_Owner_Households_Valued_50000_59999_Pct":2.54,"housing_Owner_Households_Valued_60000_69999_Pct":3.06,"housing_Owner_Households_Valued_70000_79999_Pct":2.86,"housing_Owner_Households_Valued_80000_89999_Pct":3.25,"housing_Owner_Households_Valued_90000_99999_Pct":2.33,"housing_Owner_Households_Valued_100000_124999_Pct":6.24,"housing_Owner_Households_Valued_125000_149999_Pct":6.30,"housing_Owner_Households_Valued_150000_174999_Pct":7.31,"housing_Owner_Households_Valued_175000_199999_Pct":6.40,"housing_Owner_Households_Valued_200000_249999_Pct":14.29,"housing_Owner_Households_Valued_250000_299999_Pct":11.12,"housing_Owner_Households_Valued_300000_399999_Pct":13.57,"housing_Owner_Households_Valued_400000_499999_Pct":5.08,"housing_Owner_Households_Valued_500000_749999_Pct":4.03,"housing_Owner_Households_Valued_750000_999999_Pct":0.86,"housing_Owner_Households_Valued_1000000_Or_More_Pct":0.55,"households_Median_Vehicles":2.1,"households_With_No_Vehicles_Pct":4.79,"households_With_1_Vehicle_Pct":40.11,"households_With_2_Vehicles_Pct":37.84,"households_With_3_Vehicles_Pct":12.41,"households_With_4_Or_More_Vehicles_Pct":4.85,"housing_Median_Built_Yr":1996,"housing_Built_2010_Or_Later_Pct":26.60,"housing_Built_2000_2009_Pct":17.74,"housing_Built_1990_1999_Pct":11.34,"housing_Built_1980_1989_Pct":15.80,"housing_Built_1970_1979_Pct":18.12,"housing_Built_1960_1969_Pct":4.74,"housing_Built_1950_1959_Pct":1.87,"housing_Built_1940_1949_Pct":0.50,"housing_Built_1939_Or_Earlier_Pct":0.51,"median_Length_Of_Residence_Yr":22,"moved_In_2010_Or_Later_Pct":62.23,"moved_In_2000_2009_Pct":21.96,"moved_In_1990_1999_Pct":4.20,"moved_In_1980_1989_Pct":0.93,"moved_In_1970_1979_Pct":0.62,"moved_In_1969_Or_Earlier_Pct":0.39,"personal_Income":21726623393,"household_Income":21560408259,"median_Household_Income":0,"avg_Household_Income":83819,"household_Income_Per_Capita":35152,"household_Income_High_Income_Avg":362334,"households_Income_Less_Than_15000_Pct":9.52,"households_Income_15000_24999_Pct":9.41,"households_Income_25000_34999_Pct":9.52,"households_Income_35000_49999_Pct":13.31,"households_Income_50000_74999_Pct":17.98,"households_Income_75000_99999_Pct":12.86,"households_Income_100000_124999_Pct":9.17,"households_Income_125000_149999_Pct":5.77,"households_Income_150000_199999_Pct":6.56,"households_Income_200000_And_Over_Pct":5.90,"family_Income":17192019622,"family_Median_Income":77232,"family_Avg_Income":100849,"family_Per_Capita_Income":34117,"family_Income_High_Income_Avg":354390,"families_Income_Less_Than_15000_Pct":4.73,"families_Income_15000_24999_Pct":5.96,"families_Income_25000_34999_Pct":7.25,"families_Income_35000_49999_Pct":11.78,"families_Income_50000_74999_Pct":18.92,"families_Income_75000_99999_Pct":15.20,"families_Income_100000_124999_Pct":11.52,"families_Income_125000_149999_Pct":7.67,"families_Income_150000_199999_Pct":8.75,"families_Income_200000_And_Over_Pct":8.21,"non_Family_Income":4413168427,"non_Family_Median_Income":35846,"non_Family_Avg_Income":50870,"non_Family_Per_Capita_Income":41766,"non_Family_Income_High_Income_Avg":494960,"non_Families_Income_Less_Than_15000_Pct":18.92,"non_Families_Income_15000_24999_Pct":16.18,"non_Families_Income_25000_34999_Pct":13.98,"non_Families_Income_35000_49999_Pct":16.31,"non_Families_Income_50000_74999_Pct":16.15,"non_Families_Income_75000_99999_Pct":8.28,"non_Families_Income_100000_124999_Pct":4.54,"non_Families_Income_125000_149999_Pct":2.04,"non_Families_Income_150000_199999_Pct":2.26,"non_Families_Income_200000_And_Over_Pct":1.36,"enrollment_Public_Preprimary_Pct":0.57,"enrollment_Private_Preprimary_Pct":0.49,"enrollment_Public_Kindergarten_Pct":0.84,"enrollment_Private_Kindergarten_Pct":0.18,"enrollment_Public_Grades_1_4_Pct":3.90,"enrollment_Private_Grades_1_4_Pct":0.66,"enrollment_Public_Grades_5_8_Pct":4.40,"enrollment_Private_Grades_5_8_Pct":0.62,"enrollment_Public_Grades_9_12_Pct":3.95,"enrollment_Private_Grades_9_12_Pct":0.57,"enrollment_Public_Undergraduate_College_Pct":3.06,"enrollment_Private_Undergraduate_College_Pct":1.18,"enrollment_Public_Graduate_Or_Professional_School_Pct":0.49,"enrollment_Private_Graduate_Or_Professional_School_Pct":0.50,"enrollment_Not_Enrolled_In_School_Pct":78.59,"education_Some_Hs_Pct":8.89,"education_Hs_Pct":34.37,"education_Some_College_Pct":20.64,"education_Assoc_Degree_Pct":9.17,"education_Bach_Degree_Pct":17.68,"education_Mast_Degree_Pct":6.78,"education_Prof_Degree_Pct":1.29,"education_Doct_Degree_Pct":1.18,"education_Grad_Degree_Pct":9.25,"population_16P_Civilian_Male_Pct":26.70,"population_16P_Civilian_Female_Pct":24.25,"population_16P_Armed_Forces_Male_Pct":0.15,"population_16P_Armed_Forces_Female_Pct":0.00,"population_16P_Unemployed_Male_Pct":0.81,"population_16P_Unemployed_Female_Pct":0.74,"population_16P_Not_In_The_Labor_Force_Male_Pct":20.60,"population_16P_Not_In_The_Labor_Force_Female_Pct_Pct":26.75,"emp_Agri_Pct":0.45,"emp_Mine_Pct":0.04,"emp_Const_Pct":8.88,"emp_Manuf_Pct":4.50,"emp_Whole_Pct":2.38,"emp_Retail_Pct":14.96,"emp_Trans_Pct":3.92,"emp_Utils_Pct":0.84,"emp_Info_Pct":1.71,"emp_Finetc_Pct":6.26,"emp_Real_Pct":2.21,"emp_Prof_Pct":7.55,"emp_Manag_Pct":0.15,"emp_Admin_Pct":5.37,"emp_Educ_Pct":8.22,"emp_Health_Pct":14.68,"emp_Arts_Pct":1.82,"emp_Accom_Pct":7.58,"emp_Otsrv_Pct":4.47,"emp_Pubad_Pct":3.99,"occupation_Management_Business_And_Financial_Operations_Pct":17.54,"occupation_Professional_And_Related_Pct":22.89,"occupation_Sales_And_Office_Pct":24.51,"occupation_Service_Pct":16.81,"occupation_Farming_Fishing_And_Forestry_Pct":0.18,"occupation_Construction_Extraction_And_Maintenance_Pct":9.27,"occupation_Production_Transportation_And_Material_Moving_Pct":8.80,"occupation_White_Collar_Pct":78.23,"occupation_Blue_Collar_Pct":21.77,"private_For_Profit_Employee_Pct":69.94,"private_For_Profit_Self_Employed_Pct":5.05,"private_Not_For_Profit_Employee_Pct":6.70,"local_Government_Employee_Pct":7.52,"state_Government_Employee_Pct":2.27,"federal_Government_Employee_Pct":1.86,"not_Incorporated_Self_Employed_Pct":6.51,"unpaid_Family_Worker_Pct":0.14,"employee_Naics_Cnt":104488,"employee_Forestry_Fishing_Hunting_Agriculture_Naics_Pct":0.14,"employee_Mining_Naics_Pct":0.02,"employee_Utilities_Naics_Pct":0.84,"employee_Construction_Naics_Pct":6.96,"employee_Manufacturing_Naics_Pct":2.40,"employee_Wholesale_Trade_Naics_Pct":1.78,"employee_Retail_Trade_Naics_Pct":21.27,"employee_Transportation_Warehousing_Naics_Pct":1.50,"employee_Information_Naics_Pct":1.34,"employee_Finance_Insurance_Naics_Pct":2.94,"employee_Real_Estate_Naics_Pct":2.38,"employee_Professional_Scientific_Technical_Svcs_Naics_Pct":7.77,"employee_Management_Companies_Enterprises_Naics_Pct":1.20,"employee_Admin_Support_Waste_Management_Naics_Pct":6.08,"employee_Education_Services_Naics_Pct":2.54,"employee_Health_Care_Social_Assistance_Naics_Pct":21.05,"employee_Arts_Entertainment_Recreation_Naics_Pct":1.60,"employee_Accommodation_Food_Svcs_Naics_Pct":13.91,"employee_Other_Svcs_Excluding_Public_Admin_Naics_Pct":4.29,"establishment_Naics_Cnt":11087,"establishment_Forestry_Fishing_Hunting_Agriculture_Naics_Pct":0.23,"establishment_Mining_Naics_Pct":0.04,"establishment_Utilities_Naics_Pct":0.20,"establishment_Construction_Naics_Pct":11.09,"establishment_Manufacturing_Naics_Pct":2.05,"establishment_Wholesale_Trade_Naics_Pct":3.36,"establishment_Retail_Trade_Naics_Pct":13.54,"establishment_Transportation_Warehousing_Naics_Pct":2.90,"establishment_Information_Naics_Pct":1.33,"establishment_Finance_Insurance_Naics_Pct":5.80,"establishment_Real_Estate_Naics_Pct":6.76,"establishment_Professional_Scientific_Technical_Svcs_Naics_Pct":12.57,"establishment_Management_Companies_Enterprises_Naics_Pct":0.21,"establishment_Admin_Support_Waste_Management_Naics_Pct":7.50,"establishment_Education_Services_Naics_Pct":1.24,"establishment_Health_Care_Social_Assistance_Naics_Pct":13.91,"establishment_Arts_Entertainment_Recreation_Naics_Pct":1.52,"establishment_Accommodation_Food_Svcs_Naics_Pct":7.37,"establishment_Other_Svcs_Excluding_Public_Admin_Naics_Pct":8.39,"occupation_Soc_Cnt":113351.34,"occupation_Management_Soc_Pct":4.55,"occupation_Business_Financial_Operations_Soc_Pct":3.69,"occupation_Computer_Math_Science_Soc_Pct":1.84,"occupation_Architecture_Engineering_Soc_Pct":0.84,"occupation_Life_Physical_Social_Sciences_Soc_Pct":0.44,"occupation_Community_Social_Svcs_Soc_Pct":1.20,"occupation_Legal_Soc_Pct":0.60,"occupation_Education_Training_Library_Soc_Pct":7.65,"occupation_Art_Design_Entertainment_Sports_Media_Soc_Pct":1.28,"occupation_Healthcare_Practitioners_Tech_Ops_Soc_Pct":9.41,"occupation_Healthcare_Support_Soc_Pct":4.27,"occupation_Protective_Service_Soc_Pct":0.63,"occupation_Food_Preparation_Serving_Related_Soc_Pct":13.12,"occupation_Building_Grounds_Cleaning_Maintenance_Soc_Pct":4.28,"occupation_Personal_Care_Service_Soc_Pct":3.84,"occupation_Sales_Soc_Pct":14.03,"occupation_Administrative_Support_Soc_Pct":15.30,"occupation_Farming_Fishing_Forestry_Soc_Pct":0.35,"occupation_Construction_Extraction_Soc_Pct":4.93,"occupation_Installation_Maintenance_Repair_Soc_Pct":4.12,"occupation_Production_Operations_Soc_Pct":2.98,"occupation_Transportation_Material_Moving_Soc_Pct":5.22,"households_Heating_Fuel_Utility_Gas_Pct":4.82,"households_Heating_Fuel_Bottled_Tank_Or_Lp_Gas_Pct":0.68,"households_Heating_Fuel_Electricity_Pct":92.48,"households_Heating_Fuel_Fuel_Oil_Kerosene_Pct":0.10,"households_Heating_Fuel_Coal_Coke_Pct":0.00,"households_Heating_Fuel_Wood_Pct":0.07,"households_Heating_Fuel_Solar_Energy_Pct":0.52,"households_Heating_Fuel_Other_Fuel_Pct":0.06,"households_Heating_Fuel_None_Pct":1.28,"retail_Sales_Amt":10021821,"furniture_And_Home_Furnishing_Sales_Amt":168211,"electrical_And_Appliance_Store_Sales_Amt":68038,"building_Materials_And_Garden_Store_Sales_Amt":456933,"food_And_Beverage_Store_Sales_Amt":1431359,"health_And_Personal_Care_Store_Sales_Amt":636476,"gas_Station_Store_Sales_Amt":854649,"clothing_And_Accessories_Store_Sales_Amt":328219,"sporting_Goods_Store_Sales_Amt":67693,"general_Merchandise_Store_Sales_Amt":1738996,"miscellaneous_Store_Sales_Amt":157614,"non_Store_Purchase_Sales_Amt":493006,"food_Services_Sales_Amt":922670,"consumerPriceIndex":219.3,"consumerPriceIndex_Apparel":152.5,"consumerPriceIndex_Education_And_Communications":139.0,"consumerPriceIndex_Food_And_Beverages":221.1,"consumerPriceIndex_Other_Goods_And_Services":292.6,"consumerPriceIndex_Housing":216.3,"consumerPriceIndex_Medical_Care":405.2,"consumerPriceIndex_Recreation":122.9,"consumerPriceIndex_Transportation":192.3,"costIndex_Annual_Expenditures":104.6,"costIndex_Food":103.9,"costIndex_Food_At_Home":103.9,"costIndex_Cereals_And_Bakery_Products":103.9,"costIndex_Dairy":103.4,"costIndex_Fruits_And_Vegetables":104.4,"costIndex_Non_Alcoholic_Beverages":103.6,"costIndex_Food_Prepared_By_Consumer_Unit_On_Trips":104.3,"costIndex_Local_Restaurants":104.3,"costIndex_Restaurants_On_Trips":105.8,"costIndex_Alcoholic_Beverages":104.2,"costIndex_Housing":104.4,"costIndex_Household_Operations":104.5,"costIndex_Housekeeping_Services":106.4,"costIndex_Household_Furnishings_And_Equipment":104.7,"costIndex_Household_Textiles":104.9,"costIndex_Furniture":105.1,"costIndex_Floor_Coverings":106.0,"costIndex_Major_Appliances":104.0,"costIndex_Small_Appliances":104.3,"costIndex_Miscellaneous_Household_Equipment":104.5,"costIndex_Apparel_And_Services":104.6,"costIndex_Men_And_Boys":104.2,"costIndex_Men_16_And_Over":104.3,"costIndex_Apparel_Boys":105.7,"costIndex_Women_And_Girls":104.2,"costIndex_Women_16_And_Over":104.5,"costIndex_Apparel_Girls":104.2,"costIndex_Apparel_Children":101.6,"costIndex_Footwear":104.4,"costIndex_Other_Apparel_Products_And_Services":107.9,"costIndex_Transportation":103.7,"costIndex_Vehicle_Purchase_Net_Outlay":103.8,"costIndex_Gasoline_And_Motor_Oil":103.2,"costIndex_Other_Vehicle_Expenses":103.8,"costIndex_Public_Transportation":107.6,"costIndex_Healthcare":103.9,"costIndex_Health_Insurance":104.2,"costIndex_Medical_Services":103.1,"costIndex_Drugs":103.8,"costIndex_Medical_Supplies":103.9,"costIndex_Entertainment":103.9,"costIndex_Fees_And_Admissions":106.8,"costIndex_Audio_And_Visual_Equipment_And_Services":103.6,"costIndex_Pets_Toys_Hobbies_And_Playground_Equipment":102.5,"costIndex_Other_Entertainment_Supplies_Equipment_And_Services":104.1,"costIndex_Personal_Care_Products_And_Services":104.5,"costIndex_Reading":104.7,"costIndex_Education":110.3,"costIndex_Tobacco":101.7,"costIndex_Cash_Contributions":104.8,"costIndex_Personal_Insurance_And_Pensions":108.1,"home_Maintenance_Repairs_Insurance_And_Other_Expenses":104.6,"utilities_Fuels_And_Public_Services":103.8,"natural_Gas":104.2,"costIndex_Electricity":103.4,"phone_Residential":104.1,"phone_Cellular":103.4},"crime":{"mortality_Index":0,"murder_Index":0,"forcible_Rape_Index":0,"forcible_Robbery_Index":0,"aggravated_Assault_Index":0,"burglary_Index":0,"larceny_Index":0,"motor_Vehicle_Theft_Index":0,"crime_Index":0},"airQuality":{"ozone_Index":106,"lead_Index":167,"carbon_Monoxide_Index":94,"nitrogen_Dioxide_Index":84,"particulate_Matter_Index":105,"air_Pollution_Index":106},"climate":{"annual_Avg_Temp_Min":61.63,"annual_Avg_Temp_Max":82.32,"annual_Avg_Temp":0,"possible_Sunshine_Pct":66,"sky_Cover_Mean":6,"clear_Day_Mean":102,"rainy_Day_Mean":106,"snow_Day_Mean":0,"annual_Precip_In":0,"annual_Snowfall_In":0,"avg_Jan_Low_Temp":49.14,"avg_Feb_Low_Temp":50.86,"avg_Mar_Low_Temp":55.28,"avg_Apr_Low_Temp":59.80,"avg_May_Low_Temp":65.56,"avg_Jun_Low_Temp":70.91,"avg_Jul_Low_Temp":72.57,"avg_Aug_Low_Temp":72.75,"avg_Sep_Low_Temp":71.30,"avg_Oct_Low_Temp":64.49,"avg_Nov_Low_Temp":56.36,"avg_Dec_Low_Temp":50.55,"avg_Jan_High_Temp":71.20,"avg_Feb_High_Temp":73.10,"avg_Mar_High_Temp":77.57,"avg_Apr_High_Temp":82.34,"avg_May_High_Temp":87.35,"avg_Jun_High_Temp":90.04,"avg_Jul_High_Temp":90.89,"avg_Aug_High_Temp":91.05,"avg_Sep_High_Temp":89.50,"avg_Oct_High_Temp":84.36,"avg_Nov_High_Temp":77.89,"avg_Dec_High_Temp":72.54,"avg_Jan_Precip_In":3.18,"avg_Feb_Precip_In":3.11,"avg_Mar_Precip_In":3.95,"avg_Apr_Precip_In":2.24,"avg_May_Precip_In":3.38,"avg_Jun_Precip_In":6.76,"avg_Jul_Precip_In":7.41,"avg_Aug_Precip_In":7.80,"avg_Sep_Precip_In":7.07,"avg_Oct_Precip_In":2.72,"avg_Nov_Precip_In":2.29,"avg_Dec_Precip_In":2.72},"naturalDisasters":{"weather_Index":0,"earthquake_Index":0,"hail_Index":0,"hurricane_Index":0,"tornado_Index":0,"wind_Index":0}}}
  const [listings, setListings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [listing, setListing] = useState(null);
  const [shareLinkCopied, setShareLinkCopied] = useState(false);
  const [contactLandlord, setContactLandlord] = useState(false);
  const [lastFetchedListing, setLastFetchListing] = useState(null);
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [clickedSuggestion, setClickedSuggestion] = useState("");
  const [user, setUser] = useState(null);
  const [propertyInfo, setPropertyInfo] = useState(null);
  const [imageSrc, setImageSrc] = useState("");
  const [countyData, setCountyData] = useState(null); // State for API data
  const [crimeData, setCrimeData] = useState(null); // State for API data
  const [clicked, setClicked] = useState(0); // State for API data
  const [filter, setFilter] = useState("");
  const [rentData, setRentData] = useState(null);
  const [error, setError] = useState(null);
  const [loading1, setLoading1] = useState(false);
  const [bedroomInput, setBedroomInput] = useState("");
const [bathroomInput, setBathroomInput] = useState("");
  const mapContainerStyle = {
    width: "100%",
    height: "400px",
    borderRadius: "12px",
  };


  useEffect(() => {
    setTimeout(()=>{

    firebase
      .firestore()
      .collection("users")
      .doc(currentUser.uid)
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setUser(snapshot.data());
          console.log("USERID", currentUser.uid)
          console.log("USER", user)

        } else {
          console.log("does not exist");
        }
      });
    }, 1000)
}, []);


const DealExplorerUpsell = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button onClick={handleOpen}>Deal Explorer</button>
      <UpsellModal open={open} onClose={handleClose} />
    </>
  );
};


const fetchRentEstimate = async (encodedAddress) => {
  setLoading1(true); // Start loading

  try {
    const response = await fetch(
      `https://api.rentcast.io/v1/avm/rent/long-term?address=${
        encodedAddress
      }&bedrooms=${bedroomInput || ""}&bathrooms=${bathroomInput || ""}`,
      {
        headers: {
          "X-API-Key": "3bf99588906842468bdd81d2e38d0083",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    setRentData(data); // Ensure state updates
    console.log("Rent data has been set", data);

  } catch (error) {
    console.error("Error fetching rent estimate:", error);
    setError(error.message);
  } finally {
    setLoading1(false); // Stop loading
  }
};



const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const basicdata =
countyData?.data?.basicdata && Array.isArray(countyData.data.basicdata)
  ? countyData.data.basicdata
  : null;

  const filteredData = basicdata
  ? basicdata.filter((row) =>
      row.zip_code && row.zip_code.toString().includes(filter)
    )
  : [];

  
  

const handleInputChange = (event) => {
  const value = event.target.value;
  setInput(value);

  if (value.length > 2) {
    const autocompleteService = new window.google.maps.places.AutocompleteService();

    autocompleteService.getPlacePredictions(
      {
        input: value,
        types: ['address'],
        componentRestrictions: { country: 'us' },
      },
      (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
          setSuggestions(predictions.map((item) => item.description));
          console.log(predictions);
        } else {
          console.error('Error fetching autocomplete suggestions:', status);
        }
      }
    );
  } else {
    setSuggestions([]);
  }
};
const OpenModalButton = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button onClick={handleOpen}>Housing Authority</button>
      <StateModal open={open} onClose={handleClose} />
    </>
  );
};
const OpenModalButton2 = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button onClick={handleOpen}>Tenant Lookup</button>
      <TenantModal open={open} onClose={handleClose} />
    </>
  );
};

  // const fetchPropertyData = async () => {
  //   const url = "https://api.gateway.attomdata.com/propertyapi/v1.0.0/property/basicprofile";
  //   const params = new URLSearchParams({
  //     address1: "1045 Pomme De Pin Ln",
  //     address2: "New Port Richey, FL",
  //   });

  //   try {
  //     const response = await fetch(`${url}?${params.toString()}`, {
  //       headers: {
  //         "Accept": "application/json",
  //         "APIKey": "b38c60f63ce05ed8f003d2388313f574", // Replace with your actual API key
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     setPropertyInfo(data);
  //   } catch (err) {
  //     setError(err.message);
  //   }
  


  // }

  function splitAddress(address) {
    // Regular expression to split the address into street address and city/state

    const addressStr = String(address);

    console.log("addressstr", addressStr)
    const regex = /^(.*?),\s*(.*)$/;
    const match = addressStr.match(regex);
  
    if (match) {
      return {
        address1: match[1], // The part before the first comma
        address2: match[2], // The part after the first comma
      };
    }
  
    // If the address doesn't match the expected format, return null
    return null;
  }
  
  // Example usage
 


    
    


  

  const handleSuggestionClick = async (suggestion) => {
    console.log(suggestion)
    const result = splitAddress(suggestion);
    const encodedAddress = encodeURIComponent(suggestion)
    console.log(encodedAddress)
    const address1 = result["address1"];
    const address2 = result["address2"];

    setClickedSuggestion(suggestion);
    setInput(suggestion);
    fetchRentEstimate(encodedAddress)

    // await fetchPropertyData(address1, address2);

    setSuggestions([]);
};

  


  // Calculate meter percentage


  const { 
    rent = "N/A", 
    rentRangeLow = 0, 
    rentRangeHigh = 0, 
    latitude = null, 
    longitude = null, 
    comparables = [] 
  } = rentData || {}; 
  // Load Google Maps API
  // const { isLoaded } = useLoadScript({
  //   googleMapsApiKey: "AIzaSyDVTNByoOWDFyw4OS55EaOzJ6yzpxYjKi8", // 🔹 Replace with your Google Maps API key
  // });

  // Map Center (Subject Property)
  const mapCenter = { lat: latitude, lng: longitude };

  // State for selected marker info window
  const [selectedProperty, setSelectedProperty] = useState(null);

  // Rent Meter Calculation
  const rentPercentage = ((rent - rentRangeLow) / (rentRangeHigh - rentRangeLow)) * 100;





console.log("--------->",propertyInfo)
  
if (!user ) {
  return <div></div>
} else
  return (
  
      <div className="offer" style={{ backgroundColor: '#f1f4f9'}}>
       
        {/* <OpenModalButton/> */}
  
        <div style={{ display: "flex",  }}>
  <Sidebar
    style={{
      backgroundColor: '#000222',
      flex: '0 0 250px', // Fixed width for the sidebar
    }}
  >
            <Menu style={{ backgroundColor: '#000222' }}>
              <MenuItem>
                <div style={{ marginLeft: -43, backgroundColor: 'white' }}>
                  <img
                    src="https://i.ibb.co/s2dBvDt/elevate.png"
                    alt="logo"
                    className="ml-4 mt-12 -p-4 "
                    width={300}
                  ></img>
                </div>
              </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white', marginTop: '50px' }} onClick={() => window.location = 'fmrexplorer'} icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'propertylookup'} icon={<SearchIcon />}>Market Research</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealcalculator'} icon={<CalculateIcon />}>Deal Calculator</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealexplorer'} icon={<AddHomeIcon />}>Deal Explorer</MenuItem>

              
<MenuItem
  style={{
    backgroundColor: '#000222',
    color: 'white',
    fontSize: 18,
    display: 'flex',
    alignItems: 'center',
  }}
  onClick={() => window.location = 'dealexplorerai'}
>
  <span style={{ display: 'flex', alignItems: 'center' }}>
    <AutoAwesomeIcon fontSize="small" style={{ marginRight:18}}/>
    Deal Explorer Ai
    <Chip
      label="beta"
      size="small"
      style={{
        backgroundColor: 'white',
        color: '#000222',
        fontSize: 10,
        fontWeight: 600,
        height: 18,
        borderRadius: 9999,
        marginLeft:4
      }}
    />
  </span>
</MenuItem>   

              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'skiptrace'} icon={<VisibilityIcon />}>Skip Trace</MenuItem>

<MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'rentcast'} icon={<SpeedIcon />}>Rent Reveal</MenuItem>
                <MenuItem style={{ color: 'white', backgroundColor: '#000222' }} icon={<HouseIcon />}> <OpenModalButton /> </MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<EmojiPeopleIcon />}> <OpenModalButton2 /> </MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<SupportIcon />} onClick={() => window.open('https://elevatecoachingrei.steadilypartner.com/', "_blank")}> Landlord Insurance </MenuItem>

              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'community'} icon={<PeopleIcon />}>Community Hub</MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<ComputerSharp />} onClick={() => window.open('https://section8guys.com/training', "_blank")}> Next Webinar </MenuItem>

              <SubMenu label="Book a Session" style={{ backgroundColor: '#000222', color: 'white' }} icon={<CalendarMonth />}>
               
                <MenuItem icon={<PeopleIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/googlemeet?back=1&month=2025-01', "_blank")}>
                  1-on-1s
                </MenuItem>
                <MenuItem icon={<BusinessIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/inoffice?back=1&month=2025-01', "_blank")}>
                  Day in the Office
                </MenuItem>
                <MenuItem icon={<DirectionsCarFilledIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/ridealong?back=1&month=2025-01', "_blank")}>
                  Ride Along
                </MenuItem>
              </SubMenu>
             
    
              <SubMenu label="Investor Solutions" style={{ backgroundColor: '#000222', color: 'white' }} icon={<BusinessIcon />}>
                              <MenuItem icon={<LockIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Asset Protection </MenuItem>
                                              <MenuItem icon={<AttachMoneyIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Business Funding </MenuItem>
                <MenuItem icon={<CreditScoreIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Credit Builder </MenuItem>
                <MenuItem icon={<FaWrench />} onClick={() => window.open('https://elevatecoachingrei.thecreditbrothers.com/learn-more?entry_source=elevatecoachingrei', "_blank")}> Credit Repair </MenuItem>
                <MenuItem icon={<AddIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}>Entity Formation </MenuItem>
                <MenuItem icon={<RequestQuoteIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Taxes </MenuItem>
              </SubMenu>
                <MenuItem style={{ color: 'white', backgroundColor: '#000222' }} onClick={() => window.open('https://lendsimpli.com/elevate/', "_blank")} icon={<CurrencyExchangeIcon />}> Property Loans </MenuItem>
                              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://www.skool.com/elevate-wsection-8-8185', "_blank")} icon={<SchoolIcon />}>Skool Community</MenuItem>

              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<LogoutRoundedIcon />} onClick={() => doSignOut({ callbackUrl: '/', redirect: true })}> Logout </MenuItem>
              <div style={{ ...styles.container1, backgroundColor: '#000222' }}>
                <ProfileComponent user={user} />
              </div>
            </Menu>
          </Sidebar>
        <div className="w-40">
      </div>
        
          <>
            <main>
            {/* <div class="w-full max-w-sm min-w-[200px]">
    <input class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow" placeholder="Enter Address"/>
  </div> */}
            <div>
     
              <h1 className="offer__title2">Rent Reveal</h1>
      <h4 style= {{textAlign:'center'}}>Welcome to Rent Reveal! </h4>
      <h4 style= {{textAlign:'center', marginBottom:'10px'}}>Enter an address to pull rent for your property and surrounding properties</h4>
      <div></div>
  
      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
  <input
    type="number"
    value={bedroomInput}
    placeholder="Bedrooms"
    className="form-section__form-input"
    onChange={(e) => setBedroomInput(e.target.value)}
    style={{ flex: 1 }}
  />

  <input
    type="number"
    value={bathroomInput}
    placeholder="Bathrooms"
    className="form-section__form-input"
    onChange={(e) => setBathroomInput(e.target.value)}
    style={{ flex: 1 }}
  />
</div>
        <input
    type="text"
    value={input}
    placeholder="Enter an Address"
    className="form-section__form-input"
    onChange={handleInputChange}
    style={{width:'100%'}}
    
  />
  
  {/* <button onClick={fetchPropertyData}>GET NPR INFO</button> */}
        <ul style={styles.list}>
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              style={styles.listItem}
            >
              {suggestion}
            </li>
          ))}
        </ul>
      </div>
    
              
      {rentData ? (    
      <Card 
      sx={{ 
        width: "800px", 
        backgroundColor: "#fff", 
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "16px",
        padding: "24px",
        marginBottom: "20px" 
      }}
    >
      {/* Property Image */}
      {/* <div style={{ borderRadius: "12px", overflow: "hidden" }}>
        <img src={imageSrc} width="100%" style={{ borderRadius: "12px" }} alt="Property" />
      </div> */}

      {/* Rent Estimate & Progress Bar */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <h2 style={{ margin: 0, fontWeight: "600", color: "#2C3E50", marginTop:'-15px', marginBottom:'20px' }}>
          {clickedSuggestion}
        </h2>
        <h2 style={{ margin: 0, fontWeight: "600", color: "#2C3E50" }}>
          Estimated Rent: <span style={{ color: "#16a085" }}>${rent}</span>
        </h2>
        <div style={{ backgroundColor: "#ECF0F1", height: "12px", borderRadius: "6px", width: "80%", margin: "12px auto", position: "relative" }}>
          <div
            style={{
              width: `${rentPercentage}%`,
              background: "linear-gradient(90deg, #16a085, #27ae60)",
              height: "100%",
              borderRadius: "6px",
            }}
          ></div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", width: "80%", margin: "0 auto", fontSize: "14px", color: "#7F8C8D" }}>
          <span style={{marginLeft:'-15px'}}>${rentRangeLow}  <br/> Low Est.</span>
          <span style={{marginRight:'-15px'}}>${rentRangeHigh}<br/> High Est.</span>
        </div>
      </div>

     

      {/* Comparables Table */}
      <div style={{ marginTop: "20px" }}>
        <h3 style={{ textAlign: "center", color: "#2C3E50", fontWeight: "600" }}>Comparable Listings</h3>
        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px", fontSize: "14px" }}>
          <thead>
            <tr style={{ backgroundColor: "#F8F9FA", textAlign: "left", fontWeight: "bold" }}>
              <th style={{ padding: "12px", borderBottom: "2px solid #ECF0F1" }}>Address</th>
              <th style={{ padding: "12px", borderBottom: "2px solid #ECF0F1" }}>Beds</th>
              <th style={{ padding: "12px", borderBottom: "2px solid #ECF0F1" }}>Baths</th>
              <th style={{ padding: "12px", borderBottom: "2px solid #ECF0F1" }}>Sq Ft</th>
              <th style={{ padding: "12px", borderBottom: "2px solid #ECF0F1" }}>Price</th>
              <th style={{ padding: "12px", borderBottom: "2px solid #ECF0F1" }}>Distance (mi)</th>
            </tr>
          </thead>
          <tbody>
            {comparables.map((comp, index) => (
              <tr key={index} style={{ borderBottom: "1px solid #ECF0F1", transition: "background 0.3s" }}>
                <td style={{ padding: "12px" }}>{comp.formattedAddress}</td>
                <td style={{ padding: "12px", textAlign: "center" }}>{comp.bedrooms}</td>
                <td style={{ padding: "12px", textAlign: "center" }}>{comp.bathrooms}</td>
                <td style={{ padding: "12px", textAlign: "center" }}>{comp.squareFootage}</td>
                <td style={{ padding: "12px", color: "#16a085", fontWeight: "bold", textAlign: "center" }}>${comp.price}</td>
                <td style={{ padding: "12px", textAlign: "center" }}>{comp.distance.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
      ) : (
        <p style={{ textAlign: "center", marginTop: "20px", color: "#7F8C8D" }}></p>
      )}
       
 
             
            </main>
            
          </>
       
      </div>
      </div>
    );
  
};

export default RentCast;


const styles = {
  container: {
    margin: '20px auto',
    maxWidth: '600px',
    fontFamily: 'Arial, sans-serif',
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    width:'100%',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  listItem: {
    padding: '12px 16px',
    cursor: 'pointer',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#fff',
    width:'100%',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
  },
  listItemHover: {
    backgroundColor: '#f7f7f7',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  centerScreen: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    minHeight: '100vh'
  },
  container1: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#fff',
    alignItems: 'center',
    height: '100%',
    marginTop:'0px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#000222',
    padding: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  profileAvatar: {
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    marginRight: '21px',
  },
  profileName: {
    fontSize: '17px',
    fontWeight: 'bold',
    color: 'white',
    margin: 0,
  },
  profileHandle: {
    fontSize: '11px',
    color: 'white',
    margin: 0,
  },
  
};
